export default "__VITE_ASSET__fe69b86c__"